export const GElement_ENDPOINTS = {
  GETMEASUREMENTDATA: "/members/senfi/measurement/data",
  GETEMISSIONDATA: "/members/senfi/calculate_co2e/nxmap",
  PUBLISH_TO_SENFI: "/members/senfi/publish",
};
